import * as yup from "yup";

export const validateUpdateCampaigns = yup.object().shape({
  name: yup
    .string()
    .min(2, "El NOMBRE debe tener más de 2 caracteres"),
  status: yup
    .string()
    .oneOf(["active", "inactive"], "Debes elegir entre estas opciones"),
  products_mode: yup
    .string()
    .oneOf(
      ["category", "manual", "promotions"],
      "Debes elegir un modo de productos"
    ),
  category_id: yup
    .number()
    .nullable()
    .when("products_mode", {
      is: "category",
      then: (schema) =>
        schema
          .typeError("Selecciona una categoría")
          .required("Selecciona una categoría"),
      otherwise: (schema) => schema.nullable(),
    }),
  eyebrow: yup.string().nullable(),
  headline: yup.string().nullable(),
  description: yup.string().nullable(),
  featured_title: yup.string().nullable(),
  featured_description: yup.string().nullable(),
  hero_image: yup.string().nullable(),
  secondary_image: yup.string().nullable(),
  pill_label: yup.string().nullable(),
  pill_bg_color: yup.string().nullable(),
  pill_text_color: yup.string().nullable(),
});
